/*
* 看板数据展示
* @Author: Roger Wei
* @Date:   2020-11-07 13:49:44
* @Last Modified by:   Roger Wei
* @Last Modified time: 2020-11-12 17:10:11
*/

import request from "@/utils/request";
/**获取数据源的列表*/
export function get_source_list(params) {
  return request({
    url: '/analysis/system/analysis/source/get_source_list',
    method: "get",
    params
  });
}

/**
 * 获取定义好数据源图例样式数据
 * @return {[type]} [description]
 */
export function source_page(data) {
  return request({
    url: '/analysis/system/analysis/source/css/source_page',
    method: "post",
    data
  });
}
/**
 * 保存或更新数据源图例样式
 * @return {[type]} [description]
 */
export function save_or_update(data) {
  return request({
    url: '/analysis/system/analysis/source/css/save_or_update',
    method: "post",
    data
  });
}

/**获取数展示图例的列表*/
export function get_detail(params) {
  return request({
    url: '/analysis/system/analysis/source/html/get_detail',
    method: "get",
    params
  });
}

/**保存数展示图例的列表*/
export function htmlsave_or_update(data) {
  return request({
    url: '/analysis/system/analysis/source/html/save_or_update',
    method: "post",
    data
  });
}

/**更新拉取数据*/
export function update_publish_status(params) {
  return request({
    url: '/analysis/system/analysis/source/css/update_publish_status',
    method: "get",
    params
  });
}

















/**
 * 获取布局数据
 * @return {[type]} [description]
 */
export function source_publish_page(data) {
  return request({
    url: '/analysis/system/analysis/source/css/source_publish_page',
    method: "post",
    data
  });
}





